// client/requestHandlers/synchronousDedupe.ts
import { PassthroughHandler } from "../../requestHandler.js";
var SynchronousDedupe = class extends PassthroughHandler {
  constructor(upstream, map = {}) {
    super(upstream);
    this.map = map;
  }
  async query(op, payload) {
    const key = JSON.stringify(payload);
    const deduped = this.map[key];
    if (deduped)
      return deduped;
    const query = this.upstream.query(op, payload).finally(() => {
      delete this.map[key];
    });
    this.map[key] = query;
    return query;
  }
  destroy() {
    this.map = {};
    super.destroy();
  }
};
export {
  SynchronousDedupe
};
